import {
  ArrowRight,
  Award,
  Users,
  Heart,
  Clock,
  Target,
  ScanSearch,
} from "lucide-react";
import { motion } from "framer-motion";
import { Footer } from "../../Footer";
import { Nav } from "../../Nav";
import { ContactForm } from "./ContactForm";
import { TestimonialSwiper } from "../../TestimonialSwiper";
import img2 from "../../../assets/vector2.png";
import img1 from "../../../assets/Vector1.png";
import img3 from "../../../assets/about-story.png";
import img4 from "../../../assets/about-bg.jpg";
import img5 from "../../../assets/about-mission.png";
import icon1 from "../../../assets/icons/visuals.png";
import icon2 from "../../../assets/icons/creation.png";
import icon3 from "../../../assets/icons/content.png";
import icon4 from "../../../assets/icons/access.png";
import { useState } from "react";
import { useAuth } from "../../../AuthProvider";
import { useNavigate } from "react-router-dom";

export const About = () => {
  // const { currentUser } = useAuth();
  // const navigate = useNavigate();

  // const handleGetStarted = async () => {
  //   if (currentUser) {
  //     // If already logged in, go directly to dashboard
  //     navigate("/virtual-ai-model");
  //   } else {
  //     // Otherwise, redirect to login/signup
  //     navigate("/login");
  //   }
  // };

  // Animation variants
  // const fadeIn = {
  //   hidden: { opacity: 0, y: 20 },
  //   visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
  // };

  const [isExpanded, setIsExpanded] = useState(false);

    const { currentUser } = useAuth();
  const navigate = useNavigate();

    const handleGetStarted = async () => {
        if (currentUser) {
          // If already logged in, go directly to dashboard
          navigate("/ai-model");
        } else {
          // Otherwise, redirect to login/signup
          navigate("/login");
        }
      };

  return (
    <>
      <div className="w-full overflow-hidden">
        <Nav />

        {/* Hero Section */}
        <div className="relative overflow-hidden">
          <div className="md:max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="relative z-10 flex flex-col items-center justify-between py-12 md:py-10">
              {/* Hero content */}
              <div className="top flex flex-col md:flex-row items-center justify-between gap-4 md:gap-8 w-full mb-5">
                <div className="top-left flex items-start justify-center flex-col gap-5 md:w-[45vw] ">
                  <button className="text-[16px] rounded-full px-2 py-1 bg-[#F8F4F3]">
                    About US
                  </button>
                  <p className="text-[40px] font-semibold leading-tight">
                    Redefining the Future of Fashion Visualization
                  </p>
                </div>
                <div className="top-right flex items-start justify-center flex-col gap-5 md:w-[25vw]">
                  <p className="text-[20px]">
                    Gomens is your AI-powered creative partner—transforming
                    your garment photos into stunning, on-model imagery instantly, without design
                    expertise.
                  </p>
                  <button className="cursor-pointer bg-black text-white rounded-lg px-[20px] py-[10px]" onClick={handleGetStarted}>
                    Start Creating for free
                  </button>
                </div>
              </div>
              <div className="bottom rounded-2xl overflow-hidden md:mt-10  md:h-[500px] relative  md:w-[1280px]">
                <img
                  src={img4}
                  alt="about-page-image"
                  className=" md:w-full w-[343px] md:h-[500px] h-[343px] object-cover"
                />
              </div>
            </div>
          </div>

          {/* Decorative elements - same as home page */}
          <div className="absolute top-0 right-0 -mt-20 -mr-20 hidden lg:block">
            <svg width="404" height="404" fill="none" viewBox="0 0 404 404">
              <defs>
                <pattern
                  id="pattern-circles"
                  x="0"
                  y="0"
                  width="20"
                  height="20"
                  patternUnits="userSpaceOnUse"
                >
                  <circle
                    cx="10"
                    cy="10"
                    r="2"
                    fill="rgba(124, 58, 237, 0.1)"
                  />
                </pattern>
              </defs>
              <rect width="404" height="404" fill="url(#pattern-circles)" />
            </svg>
          </div>
        </div>
        {/* Stats Section */}
        <section className="py-16">
          <div className="max-w-7xl mx-auto px-3">
            <div className="grid grid-cols-2 md:grid-cols-4 md:gap-8 gap-4 text-center">
              {[
                {
                  number: "20K+",
                  label: "Image Processed",
                },
                {
                  number: "5K+",
                  label: "Active Users",
                },
                {
                  number: "8K+",
                  label: "Designers Joined",
                },
                {
                  number: "98%",
                  label: "Accuracy Rate",
                },
              ].map((stat, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1, duration: 0.5 }}
                  viewport={{ once: true }}
                  className="p-6 bg-white rounded-xl shadow-sm"
                >
                  <p className="md:text-[48px] text-[40px] font-bold text-gray-900 mb-2">
                    {stat.number}
                  </p>
                  <p className="text-gray-600 text-[16px] md:text-[20px]">{stat.label}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* Our Story Section */}
        <section className="py-16 bg-white">
          <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-20">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              className="md:flex md:items-center md:justify-between gap-12"
            >
              {/* <div className="md:w-[55vw] mb-10 md:mb-0"> */}
              <div className="mx-auto mb-10 md:mb-0">
                <div className="text-[20px] inline-block px-3 py-1 text-sm font-semibold text-violet-600 mb-4">
                  Our Story
                </div>
    
                <img src={img3} alt="Our journey" className="float-right mx-auto h-auto" />          
                <p className="text-[18px] mb-6 text-wrap">
                  For decades, the vibrant world of fashion has relied
                  on <strong>traditional photoshoots</strong>. While effective, this process
                  is plagued by <strong>high costs, slow execution</strong> that takes weeks,
                  and <strong>limited flexibility.</strong> In a world where fashion cycles
                  are <strong>faster than ever</strong> and consumer attention is
                  fragmented, static, slow, and costly methods simply <strong>cannot
                  keep pace.</strong> Showcasing garments on <strong>varied body types, 
                  skin tones, and cultural contexts</strong> has also been a 
                  resource-intensive challenge.
                </p>
                <h2 className="text-[30px] md:text-[40px] font-bold mb-6">
                  Our AI-Driven Solution
                </h2>                
                
                <p className="text-[18px] mb-6 text-wrap">
                  Gomens was built on the belief that the future of fashion 
                  demands agility, scalability, and inclusivity. 
                  We recognized the persistent pain point of traditional 
                  visualization and saw an opportunity to bridge the gap 
                  between <strong>cutting-edge artificial 
                  intelligence</strong> and the dynamic needs of fashion businesses.
                </p> 
                <p className="text-[18px] mb-6 text-wrap">
                  Our SaaS platform transforms how fashion brands, retailers, 
                  and designers bring their collections to life. We are the 
                  <strong> digital photography studio of the future</strong>, 
                  providing the new standard of 
                  <strong> AI-driven fashion visualization</strong>.
                </p>                               
                {isExpanded && (
                  <>
                    <p className="text-[18px] mb-6">
                      Our core function is to convert simple garment images into 
                      <strong> dynamic AI-generated model shots</strong> across 
                      <strong> diverse poses, styles, and demographics. </strong> 
                      This empowers you to showcase 
                      <strong> every garment effortlessly, authentically, and 
                      instantly—without the cost or constraints of 
                      traditional photoshoots.</strong>
                    </p>
                 
                    <h2 className="text-[30px] md:text-[40px] font-bold mb-6">
                      Empowering Fashion Businesses
                    </h2>  

                    <p className="text-[18px] mb-6">
                      Our platform is an all-in-one solution designed to accelerate your business:
                    </p>
                    <ul className="list-disc list-inside mb-6">
                      <li className="text-[18px] mb-2">
                        <strong>For Brands & Retailers: Go from design to display in minutes, 
                        not months</strong>—expand your lookbook without expanding your budget.
                        <ul className="list-disc list-inside ml-6 mb-2">
                          <li><strong>Cost Savings:</strong> Reduce photoshoot 
                          budgets by up to <strong>80%</strong>.</li>
                          <li><strong>Scalability:</strong> Effortlessly scale imagery generation 
                          from 10 garments to <strong>10,000</strong> without added complexity.</li>
                        </ul>
                      </li>
                      <li className="text-[18px] mb-2">
                        <strong>For Designers:</strong> <strong>Turn your samples into 
                        styled campaign-ready visuals</strong>, fueling creativity and speed.
                      </li>
                      <li className="text-[18px] mb-2">
                        <strong>For Marketers:</strong> Craft campaigns with <strong>diverse, 
                        inclusive, and scalable imagery</strong> tailored to your audience.
                        <ul className="list-disc list-inside ml-6 mb-2">
                          <li><strong>Inclusivity:</strong> Access <strong>varied poses, body types, 
                            and demographics</strong>.
                          </li>
                        </ul>
                      </li>
                      <li className="text-[18px] mb-2">
                        <strong>For E-Commerce Teams:</strong> Populate product catalogs with 
                        <strong> consistent, high-quality model images</strong> that drive conversion.
                        <ul className="list-disc list-inside ml-6 mb-2">  
                          <li><strong>Time Efficiency: Instantly generate high-quality images</strong>, 
                          accelerating go-to-market timelines.</li>
                        </ul>
                      </li>
                    </ul>
                    <p className="text-[18px] mb-6">
                      We are redefining what it means to <strong>see</strong> fashion. 
                      Our mission is to <strong>democratize access to world-class 
                      visuals</strong> for every fashion business, whether 
                      emerging or established. We are not replacing 
                      creativity; we are <strong>expanding it</strong>. We are focused 
                      on freeing your imagination with <strong>limitless 
                      visualization options</strong>.
                    </p>

                    <h2 className="text-[30px] md:text-[40px] font-bold mb-6">
                      Join the Future of Imagery
                    </h2> 

                    <p className="text-[18px] mb-6">
                      We invite <strong>forward-thinking fashion businesses</strong> to step into the 
                      future of imagery. Leave behind outdated models of production, 
                      embrace agility, and unlock creativity with AI-driven 
                      fashion visualization.
                    </p>
                    <p className="text-[18px] mb-6">
                      This is not just technology. It is the new language of fashion.
                    </p>
                  </>
                )}
                <button
                  className="cursor-pointer border-1 border-[#CDD5DF] py-4 px-6 rounded-xl mt-4"
                  onClick={() => setIsExpanded(!isExpanded)}
                >
                  {isExpanded ? "Read less" : "Read more"}
                </button>                
              </div>
            {/*<div className="relative">
                <img src={img3} alt="Our journey" className="float-right md:w-[45vw] h-auto" />
              </div> */}
            </motion.div>
          </div>
        </section>

        {/* our mission and vision */}
        <section>
          <div className="flex items-center justify-center flex-col px-5">
            <p className="text-[20px] text-[#5937F8] font-semibold">
              Our Mission & Vision
            </p>
            <h3 className="text-[30px] md:text-[40px] mt-[6px] text-center">
              Driven by Purpose, Powered by AI
            </h3>
            <p className="text-[18px] mb-[60px] text-center">
              At Gomens, our mission and vision fuel every innovation.
            </p>
          </div>
          <div className="flex md:items-start items-center justify-center md:flex-row flex-col gap-[24px]">
            <div className="left flex items-center flex-col justify-center gap-[20px]">
              <div className="left-top w-[380px] h-[228px] bg-[#fafafa] shadow-lg rounded-xl p-[24px]">
                <div className="icon">
                  <img src={icon1} alt="icon1" />
                </div>
                <h4 className="text-[22px] mt-[16px]">Visual Democratization</h4>
                <p className="text-[16px] mt-[16px]">
                  Give creators the freedom to bring their designs to life 
                  without a high budget and advanced tools, training, or large teams.
                </p>
              </div>
              <div className="left-bottom  w-[380px] h-[228px] bg-[#fafafa] shadow-lg rounded-xl p-[24px]">
                <div className="icon">
                  <img src={icon2} alt="icon1" />
                </div>
                <h4 className="text-[22px] mt-[16px]">Effortless Creation</h4>
                <p className="text-[16px] mt-[16px]">
                  Remove friction from the process with instant, AI-driven
                  features that accelerate every design and content workflow.
                </p>
              </div>
            </div>
            <div className="center md:w-[472px] md:h-[500px]  ">
              <img
                src={img5}
                alt=""
                className="md:w-[472px] w-[343px] h-[343px] md:h-[480px] rounded-2xl"
              />
            </div>
            <div className="right flex items-center justify-center flex-col gap-[20px]">
              <div className="right-top  w-[380px] h-[228px] bg-[#fafafa] shadow-lg rounded-xl p-[24px]">
                <div className="icon">
                  <img src={icon3} alt="icon1" />
                </div>
                <h4 className="text-[22px] mt-[16px]">
                  Diversity & Inclusion
                </h4>
                <p className="text-[16px] mt-[16px]">
                  Appeal to a diverse audience by leveraging our portfolio of 
                  diverse models and poses, leaving no one out.
                </p>
              </div>
              <div className="right-bottom  w-[380px] h-[228px] bg-[#fafafa] shadow-lg rounded-xl p-[24px]">
                <div className="icon mb-[16px]">
                  <img src={icon4} alt="icon1" />
                </div>
                <h4 className="text-[22px]">Universal Access</h4>
                <p className="text-[16px] mt-[16px]">
                  Whether you're a solo entrepreneur or a marketing team, Gomens
                  scales creative tools for everyone, everywhere.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Team Section */}
        <TestimonialSwiper />

           {/* CTA Section */}
                <section className="py-12 sm:py-16 bg-white px-4 sm:px-6 md:px-8 lg:px-16">
                  <div className="max-w-7xl xl:max-w-8xl mx-auto">
                    <motion.div
                      initial={{ opacity: 0, scale: 0.95 }}
                      whileInView={{ opacity: 1, scale: 1 }}
                      transition={{ duration: 0.5 }}
                      viewport={{ once: true }}
                      className="relative rounded-2xl sm:rounded-3xl overflow-hidden bg-black min-h-[300px] sm:min-h-[350px] md:min-h-[400px] lg:h-[400px]"
                    >
                      <div className="relative px-4 sm:px-6 md:px-8 lg:px-12 xl:px-32 py-8 sm:py-12 md:py-16 h-full flex items-center">
                        {/* Background Images */}
                        <img
                          className="hidden sm:block object-cover absolute top-2 left-2 w-16 sm:w-20 md:w-24 lg:w-auto h-auto opacity-50"
                          src={img1}
                          alt=""
                        />
                        <img
                          className="hidden sm:block object-cover absolute bottom-4 right-4 sm:right-6 w-16 sm:w-20 md:w-24 lg:w-auto h-auto opacity-50"
                          src={img2}
                          alt=""
                        />
        
                        <div className="text-center flex items-center justify-center flex-col w-full z-10 relative">
                          <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-[56px] font-bold text-white leading-tight sm:leading-tight md:leading-tight lg:leading-[4vw] font-[Playfair-Display] mb-4 sm:mb-6">
                            Generate Consistent, Hight-Quality Model Images That Drive Conversion
                          </h2>
                          <p className="text-sm sm:text-base md:text-lg lg:text-[20px] text-gray-300 w-full sm:w-[90%] md:w-[80%] lg:w-[65%] xl:w-[55%] mb-6 sm:mb-8">
                            Join thousands using Gomens to drive conversion through visuals.
                          </p>
                          <div>
                            <a
                              href="/pricing"
                              className="inline-flex items-center justify-center px-6 sm:px-8 py-3 sm:py-4 text-sm sm:text-base font-medium rounded-lg shadow-lg bg-white text-black hover:bg-gray-100 transition-all duration-300"
                            >
                              Generate Your First Model (Free)
                            </a>
                          </div>
                        </div>
                      </div>
                    </motion.div>
                  </div>
                </section>

        {/* Contact Section */}
        <ContactForm />

        <Footer />
      </div>
    </>
  );
};
